import "./OutcomeCount.scss";
import { OutcomeHashtagIcon } from "mds/icons";

export const OutcomeCount = ({ count }: { count: number }) => (
  <span className="outcome-count h6 flex items-center justify-center gap-1 rounded-lg border-black-tint-90 bg-white px-2 py-1 text-black-tint-40">
    <OutcomeHashtagIcon />
    {count}
  </span>
);
